import DropdownTerminFooter from './dropdownTerminFooter'
import ConditionalDropdowns from './conditionalDropdowns'
import InitSlider from './slider'
import InitVideo from './video'
import InitHeader from './header'
import InitInputs from './inputs'
import InitSearch from './search'
import {initializeSelectMenu} from "./select-menu/select-menu-init";
import InitMobileHeader from "./mobileHeader";
import {onDomReady} from "../../shared/ts/helpers/on-dom-ready";

import "../scss/main.scss";
import InitContactWidget from "./contact-widget";

const hasInputs = !!document.querySelector('.textbox__input, .textarea__input')
const hasVideo = !!document.querySelector('.video')
const hasSearch = !!document.querySelector('.block--solr_pi_search')

onDomReady(function () {
  if (hasInputs) {
    InitInputs()
  }

  if (hasVideo) {
    InitVideo()
  }

  if (hasSearch) {
    InitSearch()
  }

  initializeSelectMenu()
  InitSlider()
  InitHeader()
  InitMobileHeader()
  InitContactWidget()

  const dropdownHiddenInput = document.querySelector('.fachgebietStandortMappingJsonUri')
  if (dropdownHiddenInput?.value) {
    fetch(dropdownHiddenInput.value)
      .then(r => r.json())
      .then(data => DropdownTerminFooter(data))
      .catch(() => {})
  }

  document.querySelectorAll('.dropdowns--conditional').forEach(el => {
    ConditionalDropdowns(el)
  })

  const headerHeight = 150
  const mobileHeaderHeight = 50

  const hash = window.location.hash
  if (hash) {
    try {
      const target = document.querySelector(hash)
      if (target) {
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - headerHeight,
          behavior: 'smooth',
        })
      }
    } catch (_) {}
  }

  document.querySelectorAll('a[href^="#"]').forEach(a => {
    a.addEventListener('click', function () {
      const href = this.getAttribute('href')
      try {
        const target = document.querySelector(href)
        if (!target) return
        const offset = window.matchMedia('only screen and (max-width: 760px)').matches
          ? mobileHeaderHeight
          : headerHeight
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.scrollY - offset,
          behavior: 'smooth',
        })
      } catch (_) {}
    })
  })
})
